import {queryParams} from '@dms/shared';

import {useQueryState} from 'shared/web';

export const useBranchId = () => {
  const [branchId] = useQueryState(queryParams.BRANCH_ID);

  return branchId ?? undefined;
};
